<template>
<div>
    <CRow>
        <CCol col="12">
            <CButton :to="{name:'roles.create'}" class="mb-2" color="primary">
                {{ $t('role.create') }}
            </CButton>
        </CCol>
    </CRow>
    <CRow>
        <CCol col="12" sm="4" md="3" class="mb-3" v-for="(role, index) in roles" :key="index">
            <CCard class="my-auto ">
                <CCardBody>
                    <span class="d-block text-center">
                        {{ role.name }} / {{ role.plural_name }}
                    </span>
                    <FaIcon
                        style="position:absolute;top:0px;left:10px;"
                        v-if="role.is_admin"
                        icon="crown"
                        class="d-block mx-auto mt-3 text-affili-golden-tainoi"
                    />
                </CCardBody>
                <CCardFooter>
                    <CLink :to="{name: 'roles.edit', params: {id: role.id}}" class="mfe-2">
                        <FaIcon icon="edit" />
                    </CLink>
                    <CLink href="#" @click="deleteModal(role)" class="mfe-2">
                        <FaIcon icon="trash" class="text-danger" />
                    </CLink>
                    <CLink v-if="!role.is_admin || true" :to="{name: 'roles.permissions', params: {id: role.id}}">
                        <FaIcon icon="key" class="text-affili-eggplant" />
                    </CLink>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
    <CPagination
        v-if="pagination.last_page > 1 && !pagination.no_paginate"
        :activePage.sync="pagination.page"
        :pages="pagination.last_page"
        size="sm"
        align="center"
        @update:activePage="fetchRoles"
    />


    <CModal
        :title="$t('role.delete')"
        color="danger"
        :show.sync="showDeleteModal"
    >
      {{ $t('role.are_you_sure_to_remove', { attribute: deleteItem.name }) }}
      <template #footer>
          <CButton @click="showDeleteModal = false" color="secondary">
              {{ $t('cancel') }}
          </CButton>
          <CButton @click="deleteRole()" color="danger">
              {{ $t('delete') }}
          </CButton>
      </template>
    </CModal>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'List',

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.fetchRoles()
        })
    },

    data() {
        return {
            showLoading: false,
            showDeleteModal: false,
            deleteItem: {}
        }
    },

    computed: {
        ...mapGetters('filterMeComponent', [
            'filterMeFields'
        ]),
        ...mapGetters('role', [
            'roles', 'pagination'
        ]),
    },

    methods: {
        fetchRoles(activePage = 1) {
            this.pagination.page = activePage
            this.showLoading = true

            return this.$store.dispatch('role/fetch', {
                page: activePage,
                ...this.filterMeFields,
            }).then(res => {
                this.showLoading = false
            })
        },
        deleteModal(role) {
            this.deleteItem = role
            this.showDeleteModal = true
        },
        deleteRole() {
            //
        }
    }
}
</script>